import React, { useState, useEffect } from 'react';

const PaymentSuccessfull = () => {
  const [countdown, setCountdown] = useState(6);

  useEffect(() => {
    if (countdown === 0) {
      window.close(); // 关闭页面
      // 或者你可以重定向到其他页面，例如：
      // window.location.href = 'https://www.nvoice.ai/app';
    }

    const timer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <>
      <div className="paymentsuccessful-full">
        <div className="paymentsuccessful-body">
          <div className="paymentsuccessful-header">
          </div>
          <div className= "paymentsuccessful-content">
              <p className='paymentsuccessful-p1'>Congratulations, payment is successful! <br></br>You have successfully upgraded to Nvoice.ai VIP.</p>
              <p className='paymentsuccessful-p2'>This page will close in {countdown} seconds.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccessfull;